export default __webpack_public_path__ + "static/media/lounge-chair.a34976aa.gif";